import { Component, type ErrorInfo, type ReactNode } from "react";
import { logger } from "../services/axiom";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

/** Class component required by React for error boundaries. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logger.error("React render error", {
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
    });
    void logger.flush();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="hero min-h-screen bg-base-200">
          <div className="hero-content text-center">
            <div className="max-w-md">
              <h1 className="text-3xl font-bold">Something went wrong</h1>
              <p className="py-4 opacity-80">
                An unexpected error occurred. Try refreshing the page.
              </p>
              <button className="btn btn-primary" onClick={() => window.location.assign("/")}>
                Go home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
